import DashboardReducer from 'store/dashboard/reducers';

export { default as dashboardSelectors } from 'store/dashboard/selectors';

export default DashboardReducer;
